import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { DialogoImportacao } from '../../componentes/importacao';

/** Base REST do importador de pessoas (framework de importação do núcleo). */
export const CAMINHO_IMPORTAR_PESSOAS = '/cadastros/parceiros';

/**
 * M1.5 e fase 2 (W14): importação de pessoas e empresas pelo diálogo do framework do núcleo (`DialogoImportacao`): colunas
 * aceitas por grupo (dados, endereço principal, conta bancária e campos personalizados), "Baixar modelo", prévia antes de
 * gravar e erros por linha. As colunas e os apelidos são os mesmos de antes (`modules/cadastros/src/parceiro/importacao.ts`).
 */
/** Rodada rlote-5 (SPEC-M1): o importador aberto pelo CRM (exige também `pipeline.criar`): os criados nascem lead. */
export const CAMINHO_IMPORTAR_LEADS = '/cadastros/parceiros/crm';

export function ImportarCsv({ aberto, aoFechar, crm }: { aberto: boolean; aoFechar: () => void; crm?: boolean }) {
  const { t } = useTranslation('cadastros');
  const qc = useQueryClient();
  // Rodada rlote-6 (ROB-B1): pelo CRM, as listas de Empresas e Contatos do CRM (`['crm', ...]`) recarregam ao terminar.
  const aoConcluir = crm ? () => void qc.invalidateQueries({ queryKey: ['crm'] }) : undefined;
  return <DialogoImportacao aberto={aberto} aoFechar={aoFechar} caminho={crm ? CAMINHO_IMPORTAR_LEADS : CAMINHO_IMPORTAR_PESSOAS} titulo={t('importar.titulo')} aoConcluir={aoConcluir} />;
}
